// ---------------------------------------------------------------------------
// UUID generation for client-created records.
//
// crypto.randomUUID() exists only in a SECURE CONTEXT. A canvasser testing on
// a phone against http://<LAN-IP>:5173 has no secure context, so the call is
// undefined and recording a visit dies with "crypto.randomUUID is not a
// function" -- at the door, which is the worst possible place for it.
//
// crypto.getRandomValues() has no such restriction, so the fallback is still
// cryptographically sound. These ids are the primary key of visits and
// person_contacts and the reason the offline push is idempotent (PLAN 5.4), so
// they have to be real v4 UUIDs, not something that merely looks like one.
// ---------------------------------------------------------------------------

function randomBytes(): Uint8Array {
  const bytes = new Uint8Array(16);
  const source = globalThis.crypto;

  if (source && typeof source.getRandomValues === 'function') {
    source.getRandomValues(bytes);
    return bytes;
  }

  // Last resort. Reachable only on a browser with no Web Crypto at all, which
  // in practice means something is very wrong; a duplicated id here would
  // collapse two visits into one row rather than corrupting either.
  for (let i = 0; i < bytes.length; i += 1) {
    bytes[i] = Math.floor(Math.random() * 256);
  }
  return bytes;
}

export function uuidv4(): string {
  const source = globalThis.crypto;
  if (source && typeof source.randomUUID === 'function') return source.randomUUID();

  const bytes = randomBytes();
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40; // version 4
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80; // variant 10xx

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return (
    `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-` +
    `${hex.slice(16, 20)}-${hex.slice(20)}`
  );
}
